import { render, staticRenderFns } from "./anime.vue?vue&type=template&id=42920226&scoped=true&"
import script from "./anime.vue?vue&type=script&lang=js&"
export * from "./anime.vue?vue&type=script&lang=js&"
import style0 from "./anime.vue?vue&type=style&index=0&id=42920226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42920226",
  null
  
)

export default component.exports